import Vue from 'vue'

import BrowserHint from './BrowserHint';

Vue.component('module-browser-hint', BrowserHint)